import { render, staticRenderFns } from "./StudyRights.vue?vue&type=template&id=3bdba84c"
import script from "./StudyRights.vue?vue&type=script&lang=js"
export * from "./StudyRights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports